import styled from 'styled-components';
import {PRIMARYCOLOR, HEADING, SPACEONE} from '../constants/constants';
import {Column, FlexSpan} from './layoutComponents';

export const Paper = Column.extend`
  box-shadow:  0 1px 3px 0 rgba(0,0,0,.2), 0 1px 1px 0 rgba(0,0,0,.14), 0 2px 1px -1px rgba(0,0,0,.12);
  justify-content: ${props => props.paperVertAlign ? props.paperVertAlign: "center"};
  align-items: center;
  background: white;
  margin: ${props => props.paperMargin ? props.paperMargin: "10px"};
  padding: ${props => props.paperPadding ? props.paperPadding: "20px"};
  margin-top: 50px;
  min-height: ${props => props.paperMinHeight ? props.paperMinHeight : "none"};
`
export const StatColumn = Column.extend`
  border-right: 2px solid rgba(0,0,0,0.7);
`

export const DottedSpan = FlexSpan.extend`
  border-bottom: 2px dotted black;
  position: relative;
  top: -13px;
  margin: 0px 5px;
  @media (max-width:500px){
    top: 5px;
  }
`

export const MenuBar = styled.section`
  background: ${props => props.connected ? PRIMARYCOLOR.COLOR : PRIMARYCOLOR.OFFLINECOLOR };
  width: 100%;
`
export const H4=styled.h4`
  padding: ${HEADING.VSPACE}px 0px;
  text-align: ${props => props.centered ? 'center':'left'};
`
export const H5=styled.h5`
  padding: ${HEADING.VSPACE}px 0px;
`

export const H2= styled.h2`
  text-align: center;
  margin-top: 30px;
`
export const Span= styled.span`
  padding: ${props => props.spanPadding ? props.spanPadding: "0px"};
  font-size: ${props => props.iconFont ? props.iconFont : "auto"};
  @media (max-width: 500px){
    font-size: ${props => props.iconFontPhone ? props.iconFontPhone : "auto"};
  }
`

export const HeaderContainer = styled.div`
  width: 100%;
  height: 200px;
box-shadow:  0 1px 3px 0 rgba(0,0,0,.2), 0 1px 1px 0 rgba(0,0,0,.14), 0 2px 1px -1px rgba(0,0,0,.12);

`

export const HeroHeaderImg = styled.div`
  height: 200px;
  width: 100%;
  background: ${PRIMARYCOLOR.COLOR};
  background-image: url(${props => props.background ? props.background: "none"});
  background-position: center;
  background-size: cover;
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
@media (max-width: 500px) {

}
`

export const HeaderOverlay = styled.div`
  height: 200px;
  width: 100%;
  background: rgba(0,0,0,0.5);
  position: absolute;
  top: 42px;
  display: ${props => props.headerOverlay ? "block":"none"};
`

export const HeaderText = styled.h2`
  color: ${props => props.headerTextColour ? props.headerTextColour: "white"};
  text-align: center;
  position: relative;
  z-index: 10;
  width: ${props => props.headerTextWidth ? props.headerTextwidth: "70%"};
@media (max-width: 500px) {

  width: 70%;
}
`

export const Button=styled.button`
  max-width: 118px;
  min-width: 95px;
  border: none;
  padding: ${props => props.buttonPadding ? props.buttonPadding: "8px"};
  border-radius: 2px;
  background: ${PRIMARYCOLOR.COLOR};
  color: ${PRIMARYCOLOR.TEXTCOLOR};
  text-transform: uppercase;
  font-size: 14px;
  outline: none;
  cursor: pointer;
  text-align: center;
  text-decoration: none;
  :hover {
    background-color: #3ac182;
    a{
      color: white;
    }
    span{
      color: white;
    }
  }

  >a{
    text-decoration: none;
    color: ${PRIMARYCOLOR.TEXTCOLOR};
  }
  >a:hover{
    color: white;
  }
  @media (hover:none), (hover:on-demand) {
      :hover{
        background: ${PRIMARYCOLOR.COLOR};
        color: ${PRIMARYCOLOR.TEXTCOLOR};
        a{
          color: ${PRIMARYCOLOR.TEXTCOLOR};
        }
        span{
          color: ${PRIMARYCOLOR.TEXTCOLOR};
        }
      }
      >a:hover{
        color: ${PRIMARYCOLOR.TEXTCOLOR};
      }
  }
`


export const MenuIcon = styled.div`
  color: ${PRIMARYCOLOR.TEXTCOLOR};
  text-decoration: none;
  padding: ${SPACEONE}em;
  cursor: pointer;
  font-size: 19px;
  min-width: 50px;
  text-align: center;
  &:hover{
    color: white;
    background-color: ${PRIMARYCOLOR.HOVERCOLOR};
    i{
      color: white;
    }
	}
  >a{
    text-decoration: none;
  }
  @media (hover:none), (hover:on-demand) {
      :hover{
        background: ${PRIMARYCOLOR.COLOR};
        color: ${PRIMARYCOLOR.TEXTCOLOR};
        a{
          color: ${PRIMARYCOLOR.TEXTCOLOR};
        }
        span{
          color: ${PRIMARYCOLOR.TEXTCOLOR};
        }
        i{
          color: ${PRIMARYCOLOR.TEXTCOLOR};
        }
      }
      >a:hover{
        color: ${PRIMARYCOLOR.TEXTCOLOR};
      }
  }
`

export const MenuIconSpan = styled.i`
color:${PRIMARYCOLOR.TEXTCOLOR};
`

export const MenuText = styled.h4`
  padding: 12px;
  font-weight: 500;
  color: white;
`

export const Form = styled.form`
display: flex;
flex-direction: column;
width: 100%;
margin-bottom: 20px;
`
export const SubmitButton = styled.button`
background: ${PRIMARYCOLOR.COLOR};
border: none;
padding: 8px;
border-radius: 2px;
color: white;
text-transform: uppercase;
font-size: 12px;
text-align: center;
outline: none;
margin-top: 20px;
min-width: 95px;
  :hover {
    background-color: ${PRIMARYCOLOR.HOVERCOLOR};
    color: white;
    cursor: pointer;
  }
  :disabled {
    background-color: #efefef;
    color: ${PRIMARYCOLOR.COLOR};
  }
  :disabled:hover {
    cursor: not-allowed;
}
@media (hover:none), (hover:on-demand) {
    :hover{
      background: ${PRIMARYCOLOR.COLOR};
      color: ${PRIMARYCOLOR.TEXTCOLOR};
      a{
        color: ${PRIMARYCOLOR.TEXTCOLOR};
      }
      span{
        color: ${PRIMARYCOLOR.TEXTCOLOR};
      }
    }
    >a:hover{
      color: ${PRIMARYCOLOR.TEXTCOLOR};
    }
}
`
export const UploadButton = SubmitButton.withComponent('div');

export const InputField = styled.input`
width: 100%;
margin-top: 1.2em;
border: none;
border-bottom: 1px solid ${PRIMARYCOLOR.COLOR};
border-radius: 0px;
font-size: 16px;
:focus{
  border: none;
  outline: none;
  border-bottom: 2px solid #3ac182;
}

:disabled{
  color: rgba(0,0,0,0.3);
  user-select: none;
}
`
export const TextAreaField = styled.textarea`
width: 100%;
`
export const FormLabel = styled.h4`
margin-top: 10px;
text-align: left;
padding: 15px 0px;
`

export const FormInput = styled.label`
width: ${props => props.labelWidth ? props.labelWidth: "auto"};
`

export const FileUploadButton = styled.input`
display:none;
text-align: center;
`
export const Digit = InputField.extend`
width: ${props => props.digit ? props.digit: "2"}.2em;
text-align: right;
margin-top: 0;
padding: 0;
@media (max-width: 500px) {
  width: 2.7em;
  font-size: 22px;
}
`

export const SideNav = styled.div`
  width: 200px;
  height: 100%;
  background: white;
  position: absolute;
  left: ${props => props.open ? 0: "-100%"};
  top: 0;
  z-index: 40;
`

export const NavOverlay = styled.div`
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.4);
  position: absolute;
  left: 0;
  top: 0;
  display: ${props => props.open ? "block": "none"} ;
`

export const QuoteBlock = styled.div`
  width: 100%;
  padding: 10px;
  color: rgba(0,0,0,0.3);
  position: relative;
  bottom: 0px;
  text-align: center;
  display: flex;
  justify-content: center;
`
export const Quote = styled.div`
`

export const Quotation = styled.span`
  font-size: 32px;
  font-weight: 800;
  text-align: left;
  margin-right: 20px;
`
export const MouseText = styled.p`
  font-size: 9px;
  color: rgba(0,0,0,0.4);
  position: ${props => props.mousePos ? props.mousePos: "static"};
  top: -1em;
  margin-top: 10px;
  `

  export const HintHolder = styled.div`
  position: relative;
  `

export const Overlay = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 200;
  background: rgba(0,0,0,0.4);
  display: ${props => props.hidden ? 'none' : 'static'};
  `
export const Avatar = styled.div`
 height: 80px;
 min-width: 80px;
 max-width: 80px;
 margin-top: ${props => props.avatarMargin ? props.avatarMargin : '10px'};
 border-radius: 50%;
 box-shadow: 0 1px 3px 0 rgba(0, 0, 0, .2), 0 1px 1px 0 rgba(0, 0, 0, .14), 0 2px 1px -1px rgba(0, 0, 0, .12);
 background-size:cover;
 background-repeat:no-repeat;
 background-position:center;
 background-image: url(${props => props.avatarImg ? props.avatarImg : "none"});
`

export const ProgressContainer = styled.div`
width: 100px;
height: 20px;
background-color: #efefef;
`

export const ProgressBar = styled.div`
width: ${props => props.progressWidth ? props.progressWidth: "0"}%;
background-color: red;
height: 100%;
`



// WEBPACK FOOTER //
// ./../../../Documents/codeprojects/leaflet-v02/src/components/styledComponents.js